"use client";

import dynamic from "next/dynamic";

import type { SierraChatProps } from "./sierraChat.component";

export const SierraChat = dynamic<SierraChatProps>(
  () => import("./sierraChat.component").then((mod) => mod.SierraChat),
  {
    ssr: false,
  },
);
